import {token} from "brandi";
import container from "../../../lib/ioc";

export interface IMindboxModel {
    viewProduct: (productId: string, price: string) => void;
}

export default class MindboxModel implements IMindboxModel {
    viewProduct(productId: string, price: string) {
        window.mindbox && window.mindbox("async", {
            operation: "Website.ViewProduct",
            data: {
                viewProduct: {
                    price,
                    product: {
                        ids: {
                            website: productId
                        }
                    }
                }
            }
        });
    }
}

export const MindboxModelStoreToken = token<IMindboxModel>('MindboxModelStoreToken');

container.bind(MindboxModelStoreToken).toInstance(MindboxModel).inSingletonScope();